module.exports = __webpack_public_path__ + "static/media/icon-menu.ff0128f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-menu.svg
// module id = 1269
// module chunks = 19